var render = function render(){var _vm=this,_c=_vm._self._c;return _c('custom-btn-icon',{attrs:{"btn-text":_vm.generateMessage('requests.actions.rejection'),"color":"error","icon":"priority_high"},on:{"click":function($event){$event.stopPropagation();return _vm.handleClick.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }